export default __webpack_public_path__ + "static/media/triangle-down.9f1fcbe8.svg";